(() => {
  const name = 'services';

  App.cartPage = App.cartPage || {};
  const servicesModule = App.cartPage[name] || {};

  App.cartPage[name] = (() => {
    /**
         * Update info about all cart.
         * @param {Function} callback - function to call on success request
         * @returns {Object} jqxhr - jquery xhr
         */
    const updateQuickCart = async (callback = null) => (
      $.ajax({
        cache: false,
        method: 'GET',
        url: '/getMainOrderInfo',
      })
        .done((res) => {
          App.eventBus.trigger('cart-page:cart-updated', res);
          if (typeof callback === 'function') {
            callback(res);
          }
        })
        .fail((er) => {
          App.sendErrorToRaygun(er);
        })
    );

    const asyncDeleteFromCart = async (rowhash) => {
      try {
        const result = await $.ajax({
          url: '/removerow',
          data: {
            rowhash,
          },
        });
        return JSON.parse(result);
      } catch (err) {
        App.sendErrorToRaygun(err);
      }
      return null;
    };

    /**
         * Delete order from cart
         * @param {String} rowhash - hash of product to update
         * @param {Function} callback - function to call on success request
         */
    const deleteFromCart = (rowhash, callback) => {
      if (App.settings.pageType === 'CART_PAGE') {
        App.eventBus.trigger('cart-page:spinners:body');
      }

      $.ajax({
        url: '/removerow',
        data: {
          rowhash,
        },
      })
        .done((data) => {
          const dataJson = JSON.parse(data);
          callback(dataJson);
        })
        .fail((er) => {
          App.sendErrorToRaygun(er);
          App.ui.popup(texts('removeOrderError@product'), {
            className: 'dialog-window',
            alert: {
              ok: {
                text: texts('confirm@paymentPop'),
              },
            },
          });
        });
    };

    return {
      deleteFromCart,
      asyncDeleteFromCart,
      updateQuickCart,
      ...servicesModule,
    };
  })();
})();
